import * as React from 'react'

import { Box, Text, ToggleButton } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { AUTOMATIC_BREAK_SOURCE } from 'modules/attendance/hooks/useFetchBreakSettings'
import { BreakSettingsFormValues } from 'modules/attendance/lib/forms/BreakSettingForm'

import BreakSourceTooltip from './BreakSourceTooltip'

interface Props {
  settingForm: FormikProps<BreakSettingsFormValues>
  handleRulesToggle: () => void
}

const ToggleButtons = ({ settingForm, handleRulesToggle }: Props) => {
  const onRulesChange = () => {
    settingForm.setFieldValue('automaticBreakSource', AUTOMATIC_BREAK_SOURCE.RULES)
    handleRulesToggle()
  }

  const onPlannedHoursChange = () => {
    settingForm.setFieldValue('automaticBreakSource', AUTOMATIC_BREAK_SOURCE.PLANNED_HOURS)
  }

  return (
    <Box flexDirection="column">
      <Box flexDirection="row" paddingBottom="s12" gap="s4">
        <Text.Normal weight="medium">
          {i18n.t('time_tracking.settings.breaks.instance.break_source.activate')}
        </Text.Normal>
        <BreakSourceTooltip />
      </Box>

      <Box flexDirection="row" gap="s8">
        <ToggleButton
          toggled={settingForm.values.automaticBreakSource === AUTOMATIC_BREAK_SOURCE.RULES}
          onClick={onRulesChange}
          label={i18n.t(
            'time_tracking.settings.breaks.instance.break_source.tooltip.after_amount_of_hours.title'
          )}
        />
        <ToggleButton
          toggled={settingForm.values.automaticBreakSource === AUTOMATIC_BREAK_SOURCE.PLANNED_HOURS}
          onClick={onPlannedHoursChange}
          label={i18n.t(
            'time_tracking.settings.breaks.instance.break_source.tooltip.at_planned_time.title'
          )}
        />
      </Box>
    </Box>
  )
}

export default observer(ToggleButtons)
